/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Deep_Link_Not_FoundInputs */

const vi_expense_deep_link_not_found = /** @type {(inputs: Expense_Deep_Link_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy khoản chi này. Có thể khoản chi đã bị xoá hoặc gộp — tìm lại trong danh sách bên dưới.`)
};

/**

* @param {Expense_Deep_Link_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_deep_link_not_found = /** @type {((inputs?: Expense_Deep_Link_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Deep_Link_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_deep_link_not_found(inputs)
});